import { render, staticRenderFns } from "./NoteAndChatSP.vue?vue&type=template&id=476979dc&scoped=true"
import script from "./NoteAndChatSP.vue?vue&type=script&lang=js"
export * from "./NoteAndChatSP.vue?vue&type=script&lang=js"
import style0 from "./NoteAndChatSP.vue?vue&type=style&index=0&id=476979dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476979dc",
  null
  
)

export default component.exports